import * as fpaIcons from './fpa-icons.json';

export const fpaIconSet = fpaIcons.data;
export type FpaIcon = keyof typeof fpaIconSet;
